<template>
    <div>
        <!--頁首-->
        <Header :header="header"></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <main class="main">
            <!--網站路徑(麵包屑)-->
            <Sitebar :sider="sider" ></Sitebar>
            <BackToList v-if="Id!='' && Id!=undefined" :back_url="'?PJ_ID='+PJ_ID+'&modal='+modal"></BackToList>
            <div class="incontall inconbox">
                <SideLeft_List :sideleft="sideleft"></SideLeft_List>
                <SideRight_Image v-if="Id==''" :sideright="sideright" :pagination="pagination"></SideRight_Image>
                <!--SideRight_Content v-else :sideright="sidecontent"></SideRight_Content-->
                <SideRight_Img_Content v-else :sideright_Content="sidecontent"></SideRight_Img_Content>
            </div>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <GoTop></GoTop>
    </div>
</template> 
<script>

import Header from '../../components/default/NavBar/Header.vue';
import Menulist from '../../components/default/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default/NavBar/Menulist_RWD.vue';
import Sitebar from '../../components/default/NavBar/Sitebar.vue';
import SideLeft_List from '../../components/default/Content/SideLeft_List.vue'
import SideRight_Image from '../../components/default/Content/SideRight_Image.vue';
import SideRight_Content from '../../components/default/Content/SideRight_Content.vue';
import SideRight_Img_Content from '../../components/default/Content/SideRight_Img_Content.vue';
import Footer from '../../components/default/NavBar/Footer.vue';
import BackToList from '../../components/default/Tool/BackToList.vue';
import GoTop from '../../components/default/Tool/GoTop.vue';

export default{
    components:{
        Header,        
        Menulist,
        Menulist_RWD,
        Sitebar,
        SideLeft_List,
        SideRight_Image,
        SideRight_Content,
        SideRight_Img_Content,
        Footer,
        BackToList,
        GoTop,
    },
    data(){
        return {
            //首頁
            header:{
                text1:"國立臺灣大學生物產業傳播暨發展學系",
                text2:"最新消息",
                text3:null,
                
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:"News",
            },
            //網站路徑(麵包屑)
            sider:{
                index:2,
                type:0,
                list:[{text:"最新消息" ,url:null}],
            },
            //左側資料(列表)
            sideleft:{
                title:"最新消息",
                list:[],
            },
            sideright:{
                table_Class:"movieall",
                list_Class:"publbox",
                list:[],
            },
            sidecontent:{
                table_Class:"nwstable",
                list_Class:"newsbar",
                title: "",
                onlineDate:"",
                onlinePlace: "",
                content:"",
            },
            //頁尾
            footer:{

            },
            //頁碼
            pagination: {
                perPage: 6, //一頁幾筆
                page: 1, //目前第幾筆
                rows: 5, //一次顯示幾頁
            },
            //類別標題名稱
            title:"",
            //編號
            Id:"",
            //類別編號
            PJ_ID:"",
            //文章編號,
            type_id:"",
            //文章類型
            modal:"1",
            //語言
            langurage:"1",
        }
    },
    computed:{

    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "$route.query"(){
            //初始化
            this.init();
        },
        "pagination.page"() {
            //初始化
            this.init();
        },
    },
    methods:{
        //初始化
        init(){
            //讀取query參數
            if( this.$route.query){
                //目前頁面編號
                this.PJ_ID = this.$route.query.PJ_ID? this.$route.query.PJ_ID:"";
                //語言
                this.langurage = this.$route.query.lang? this.$route.query.lang: "1";
                //目前頁面類型
                this.modal = this.$route.query.modal? this.$route.query.modal:"2";
                //目前頁面編號
                this.Id = this.$route.query.id? this.$route.query.id:"";
    }

            //取得目前頁面資訊
            this.getHeader();
        },
        //取得目前頁面資訊
        async getHeader(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"GetHeader_front",
                    latestnews_type_SELECT:{
                        langurage :this.langurage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/LatestNewsType",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //匯入類別
                    let left_list = [];
                    jsonData.forEach((item ,index) => {
                        //若query沒有PJ_ID時，設定為第一個
                        if(this.PJ_ID =="" && index == 0){
                            this.PJ_ID = item.PJ_ID;
                        }
                        let list_item = {text:item.title, url:"/News?PJ_ID="+item.PJ_ID + "&modal="+item.modal , selected:this.PJ_ID == item.PJ_ID };
                        if(this.PJ_ID == item.PJ_ID){
                            this.type_id = item.TypeId;
                            //加入網站頁首
                            this.header.text3 = item.etitle;
                            //加入麵包屑
                            if(this.sider.list.filter(x => x.text == item.title).length == 0){
                                this.sider.list.push({text:item.title ,url:null});
                            }
                            this.title = item.title;
                        }
                        left_list.push(list_item);
                    });
                    this.sideleft.list = left_list;
    
                    if(this.Id!="") {
                        //取得目前文章內容資訊
                        this.getContent();
                    } else if (this.type_id!=""){
                        //取得目前文章列表資訊
                        this.getList();
                    }
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得目前文章列表資訊
        async getList(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    latestnews_SELECT:{
                        typeId: this.type_id,
                        langurage: this.langurage,
                        pageIndex: this.pagination.page,
                        pageSize: this.pagination.perPage,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/LatestNews",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    let list = [];

                    let jsonData = JSON.parse(json.Data);
                    if (jsonData.outData.length > 0) {
                        jsonData.outData.forEach((x) => {
                            let obj = {
                                title: x.title,
                                url:"?PJ_ID="+this.PJ_ID + "&modal="+this.modal + "&id="+x.id,
                                onlineDate: x.startDate.split('T')[0],
                                movpc: '/filestore'+x.filePath,
                            };
                            list.push(obj);
                        });
                    }else{
                        let obj = {
                            title: "",
                            url:"",
                            onlineDate: "",
                            movpc: "",
                            NotData:true,
                        }
                        list.push(obj);
                    }
                    this.sideright.list = list;
                    
                    this.pagination.rows = jsonData.totalCount;
                }
            }catch(err){
                console.log("ErrFunction: getList/n " + err);
            }
        },
        //取得目前文章內容資訊
        async getContent(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"HOME_DETAIL",
                    latestnews_SELECT:{
                        id:this.Id,
                        langurage: this.langurage,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/LatestNews",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    let jsonData = JSON.parse(json.Data);
                    this.sidecontent= {
                        title: jsonData.title,
                        onlineDate:jsonData.startDate.split('T')[0],
                        onlinePlace: jsonData.publicUnit,
                        content:this.htmlDecode(jsonData.description),
                    }
                }
            }catch(err){
                console.log("ErrFunction: getContent/n " + err);
            }
        }
    },
}
</script>